// extracted by mini-css-extract-plugin
module.exports = {"itemWrap":"Item_itemWrap__1qdrj","icon":"Item_icon__3-6wz","descWrap":"Item_descWrap__17ubB","text":"Item_text__ogkjA","number":"Item_number__3poMW"};